import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import "./styles.scss";

import { DetailsInput } from "./DetailsInput";
import { InternalLabelSelect } from "./InternalLabelSelect";
import { NotifyOnAlertCheck } from "./NotifyOnAlertCheck";
import {
  AdminLocationAlert,
  AdminLocationAlertSchema,
  defaultValues,
} from "./schema";
import { TypeSelect } from "./TypeSelect";
import { convertToSchema } from "./utils";
import { LocationAlertData } from "../../../../models/LocationAlert";
import { HookForm } from "../../../HookForm/HookForm";

export interface IAdminLocationAlertCreateFormProps {
  submit: (data: any) => Promise<void>;
  locationAlert?: LocationAlertData;
}

export const AdminLocationAlertCreateForm: React.FC<
  IAdminLocationAlertCreateFormProps
> = ({ submit, locationAlert }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`adminLocationAlertsPage.adminLocationAlertCreateModal.${key}`);

  const initialValues = locationAlert
    ? convertToSchema(locationAlert)
    : defaultValues;

  const form = useForm<AdminLocationAlert>({
    resolver: zodResolver(AdminLocationAlertSchema),
    defaultValues: initialValues,
  });

  const type = form.watch("type");

  const onSubmit = async (data: AdminLocationAlert) => {
    await submit(data);
  };

  return (
    <div className="admin-location-alert-create-form">
      <h2>{t("title")}</h2>
      <HookForm form={form} onSubmit={onSubmit}>
        <InternalLabelSelect />
        <TypeSelect />
        <DetailsInput type={type} />
        <NotifyOnAlertCheck />
      </HookForm>
    </div>
  );
};
